import { BleedsList } from "@/App/Bleeds/List";

export function PageList() {
  return <BleedsList />;
}
